import { useQuery } from '@tanstack/react-query';
import { queryKeys } from '@/services/api/queryKeys';
import { settingsApi } from '@/services/api/endpoints';
import type { StoreSettings } from '@/types/api';

/**
 * Mağaza bilgisi TEK kaynaktan gelir: backend ayarları.
 * Telefon, WhatsApp, adres, saatler hiçbir bileşene gömülmez.
 * Ayarlar nadiren değişir → uzun staleTime.
 */
export function useStoreSettings() {
  return useQuery({
    queryKey: queryKeys.settings.public,
    queryFn: settingsApi.getPublic,
    staleTime: 15 * 60 * 1000,
    gcTime: 60 * 60 * 1000,
  });
}

export function useStoreSetting<K extends keyof StoreSettings>(
  key: K,
): StoreSettings[K] | undefined {
  const { data } = useStoreSettings();
  return data?.[key];
}
